/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Knp_Lookup_Delete_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to delete some terms: {message}" |
*
* @param {Knp_Lookup_Delete_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_delete_failed_toast = /** @type {((inputs: Knp_Lookup_Delete_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Delete_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de la suppression de certains termes : ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Einige Begriffe konnten nicht gelöscht werden: ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile eliminare alcuni termini: ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось удалить некоторые термины: ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudieron eliminar algunos términos: ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`删除某些术语失败：${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`いくつかの用語を削除できませんでした: ${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`कुछ शब्दों को हटाने में विफलता: ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível excluir alguns termos: ${i?.message}`)
	return /** @type {LocalizedString} */ (`Failed to delete some terms: ${i?.message}`)
});